/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './geo-targeted-interstitial.stache';
import Cookie from 'scripts/utils/cookie';
import can from 'can';
import dtm from 'scripts/services/dtm';
import _ from 'lodash';

const promotionModalSettings = window.globalSettings.promotionModal;

Component.extend({
    tag: 'geo-targeted-interstitial',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            image: {
                Type: can.Map,
                Value: can.Map,
            },
            link: {
                Type: can.Map,
                Value: can.Map,
            },
            cookieLength: {
                type: 'number',
                value: 10 * 365 * 24 * 60 * 60,
            },
        },
    },

    events: {
        inserted() {
            if (!Cookie.getCookie('gti') && promotionModalSettings.isEnabled) {
                this.viewModel.attr('image', promotionModalSettings.image);
                this.viewModel.attr('link', promotionModalSettings.link);
                this.viewModel.attr(
                    'cookieLength',
                    promotionModalSettings.cookieLength,
                );

                let cloudinaryImage = this.element
                    .find('image-cloudinary')
                    .viewModel();
                cloudinaryImage.bind('cloudinaryImageLoaded', () => {
                    _.delay(this.showPromotionModal.bind(this), 500);
                    cloudinaryImage.unbind('cloudinaryImageLoaded');
                });
            }

            this.$trackEl = $('.c-geo-targeted-interstitial');

            this.$trackEl.on('click', this.trackClick);
        },

        removed() {
            this.$trackEl.off('click', this.trackClick);
        },

        trackClick(event) {
            event.preventDefault();

            dtm.trackClickOnPromoModal();

            if (this.getAttribute('target') === '_blank') {
                window.open(this.href);
            } else {
                window.location.reload(this.href);
            }
        },

        showPromotionModal() {
            let modal = this.element.find('modal-dialog');
            if (modal && modal.viewModel() && modal.viewModel().show) {
                modal.viewModel().show();
            }

            let expirationDate = new Date();
            expirationDate.setTime(
                expirationDate.getTime() +
                    ~~this.viewModel.attr('cookieLength') * 1000,
            );
            Cookie.createCookie(
                'gti',
                '1',
                expirationDate.toGMTString(),
                location.hostname,
            );
        },
    },
});
